import { Phase as AppPhase } from '@/features/orders/constants/app'
import { Phase as FirebasePhase } from '@/features/orders/constants/firebase'

export const firebaseToAppPhase: Record<FirebasePhase, AppPhase> = {
    [FirebasePhase.New]: AppPhase.New,
    [FirebasePhase.InProgress]: AppPhase.InProgress,
    [FirebasePhase.Future]: AppPhase.Future,
    [FirebasePhase.Archived]: AppPhase.Archived,
}
